import { render, staticRenderFns } from "./GenericControlFramework.vue?vue&type=template&id=1467837c&scoped=true&"
import script from "./GenericControlFramework.vue?vue&type=script&lang=js&"
export * from "./GenericControlFramework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467837c",
  null
  
)

export default component.exports